import { api } from '../../api/api';
import apiError from '../../api/api-error';
import localStorage from '../localStorage';
import agent from './agent';
import config from '../../config'

// initial state
const state = {
   rec: null
};

// getters
const getters = {
   getLastParcelPath: (state) => () => {
      return localStorage.get('lastParcelPath');
   },
   getExportUrl: ({ addressId, parcelId, format }) => {
      const token = agent.getters.getToken()

      let url = config.host.api + '/api/parcels/' + parcelId + '/export?format=' + format;
      if (addressId) url += '&address_id=' + addressId;
      if (token) url += '&token=' + token;

      return url;
   }
};

// actions
const actions = {
   PARCEL_COLLECT: (context, { id }) => {
      return new Promise((resolve, reject) => {
         api.get('/api/parcels/' + id)
            .then((res) => {
               context.commit('PARCEL_SET', { rec: res.data });
               resolve();
            })
            .catch((error) => {
               context.commit('ERROR_MESSAGE_SET', { message: apiError.message('parcel', error) });
               reject(error);
            });
      });
   },
   PARCEL_ZOOM_TO: (context, { }) => {
      context.commit('MAP_FIT_BOUNDS', { bounds: state.rec.bounds, maxZoom: 17, minZoom: 16 });
   },
   PARCEL_HIGHLIGHT: (context) => {
      const feature = {
         id: state.rec.featureId,
         styleLayer: 'parcels',
         source: 'scoutred',
         sourceLayer: 'parcels'
      };
      context.commit('MAP_FEATURE_ACTIVE_SET', feature);
   },
   PARCEL_MARKER: (context) => {
      if (!state.rec.address) return;

      const feature = {
         id: state.rec.id,
         geometry: state.rec.address.geom,
         properties: {
            type: 'parcel',
            noFeatureResult: true
         },
         source: 'poi',
      };
      context.commit('MAP_POI_SET', [feature]);
      context.commit('MAP_FEATURE_ACTIVE_SET', feature);
   },
   PARCEL_MARKER_CLEAR: (context) => {
      context.commit('MAP_POI_SET', null);
   },
   PARCEL_HIGHLIGHT_CLEAR: (context, { }) => {
      context.commit('MAP_FEATURE_ACTIVE_SET', null);
   },
   PARCEL_GET: (context, { id, addressId }) => {
      return new Promise((resolve, reject) => {
         let path = '/api/parcels/' + id;

         if (addressId) path += '?address_id=' + addressId;
         api.get(path)
            .then((res) => {
               let parcel = res.data;

               let sourcesMap = {};
               if (parcel.overlays && parcel.overlays.length > 0) {
                  parcel.overlays.map((overlay) => {
                     let index = overlay.sourceLayer.sourceId + '_' + overlay.sourceLayer.layerId;
                     if (!sourcesMap[index]) {
                        sourcesMap[index] = {
                           name: overlay.name,
                           category: overlay.category,
                           description: overlay.description,
                           sourceId: overlay.sourceId,
                           layerId: overlay.layerId,
                           features: []
                        };
                     }
                     sourcesMap[index].features.push(overlay);
                  });
               }
               let sourcesAry = [];
               for (let i in sourcesMap) {
                  sourcesAry.push(sourcesMap[i]);
               }

               parcel.overlaySources = sourcesAry;

               context.commit('PARCEL_SET', { rec: parcel });
               localStorage.set('lastParcelPath', path.replace('/api', '')); // store parcel path in localStorage
               resolve();
            })
            .catch((error) => {
               context.commit('ERROR_MESSAGE_SET', { message: apiError.message('parcel', error) });
               reject(apiError.message('parcel', error));
            });
      });
   },
   PARCEL_GET_DIMENSIONS: (context, { id }) => {
      return new Promise((resolve, reject) => {
         let path = `/api/parcels/${id}/dimensions`;
         api.get(path)
            .then((res) => {
               let data = res.data;

               if (data.features && data.features.map) {
                  data.features = data.features.map((feature) => {
                     const properties = feature.properties || {}
                     feature.properties = {
                        ...properties,
                        parcelId: id
                     }
                     return feature
                  })
               }

               context.commit('MAP_DIMENSIONS_SET', data);
            })
            .catch((error) => {
               context.commit('ERROR_MESSAGE_SET', { message: apiError.message('parcel', error) });
               reject(apiError.message('parcel', error));
            });
      });
   },
   PARCEL_DIMENSIONS_CLEAR: (context) => {
      context.commit('MAP_DIMENSIONS_SET', null);
   }
};

// mutations
const mutations = {
   PARCEL_SET: (state, { rec }) => {
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/parcel.js